import React from 'react';

export const ProfileEmailPage = React.lazy(() => import('./ProfileEmailPage'));
